import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled, ThemeProvider } from '@mui/material/styles';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { useNavigate } from 'react-router-dom';
import { formatNumbervalue } from '../../helpers/FormatValue';
import { yellow } from '@mui/material/colors';
import { useStatusPedido } from '../../views/hooks/statusPedido';
import { labelGrid } from '../utils';
import { transform } from 'zod';
import { temaTabela } from '../theme/themeTable';

function CustomOrderTableComponent(props: {
    data: any, deleteData: any, isHome: boolean,
    handleEditarPedido: (pedido: any) => void,
    handleVisualizarPedido?: (pedido: any) => void
}) {
    const rows = props.data;
    const [details, setDetails] = React.useState();
    const { statusPedidos, retornaOpcoesStatus } = useStatusPedido();
    const navigate = useNavigate();

    const headers = [
        'nroDocumentoPedido',
        'nroPedido',
        'nome',
        'cnpjCpf',
        'total',
        'dataLancamento',
    ]

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: '#e9f2fd',
            color: '#0f3550',
            fontSize: '12px',
            letterSpacing: '0.6px',
            padding: '4px 16px',
            borderBottom: '2px solid #d9e5ee',
            position: 'sticky',
            top: 0,
            zIndex: 2,
            whiteSpace: 'nowrap',
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: '12px',
            color: '#334155',
            padding: '5px 16px',
            borderBottom: '1px solid #E2E8F0',
        },
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        height: '32px',
        '&:nth-of-type(odd)': {
            backgroundColor: '#f8fafc',
        },
        '&:hover': {
            backgroundColor: '#eef4fb',
            transition: 'background-color 0.15s ease',
        },
        '&:last-child td, &:last-child th': {
            borderBottom: 0,
        },
    }));

    function formatarData(isoDate: string) {
        const data = new Date(isoDate);
        const dia = String(data.getDate()).padStart(2, '0');
        const mes = String(data.getMonth() + 1).padStart(2, '0');
        const ano = data.getFullYear();
        return `${dia}/${mes}/${ano}`;
    }

    function formatarValorMonetario(valor: number) {
        return `R$ ${valor.toFixed(2).replace('.', ',')}`;
    }

  function formatCnpjCpf(value: string): string {
    if (!value) return "-";

    const normalizado = value
        .normalize("NFKC")
        .replace(/[\u200B-\u200D\uFEFF]/g, "")
        .toUpperCase()
        .replace(/[./\-\s]/g, "");

    if (/^\d{11}$/.test(normalizado)) {
        return normalizado.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }

    if (/^[0-9A-Z]{12}\d{2}$/.test(normalizado)) {
        return normalizado.replace(/([0-9A-Z]{2})([0-9A-Z]{3})([0-9A-Z]{3})([0-9A-Z]{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }

    return value;
}

    return (
        <TableContainer
            component={Paper}
            sx={{
                flex: 1,
                boxShadow: 'none',
                overflow: 'auto',
                borderRadius: '4px',
                border: '1px solid #e2e8f0',
            }}
        >
            {/*  <ThemeProvider theme={temaTabela}> */}
            <Table aria-label="simple table" stickyHeader>
                <TableHead>
                    <TableRow>
                        <StyledTableCell align="center" sx={{ width: 120 }}>{labelGrid.status}</StyledTableCell>
                        <StyledTableCell align="center" sx={{ width: 130, whiteSpace: 'nowrap' }}>{labelGrid.pedidoOdin}</StyledTableCell>
                        <StyledTableCell align="center" sx={{ width: 90, whiteSpace: 'nowrap' }}>{labelGrid.pedido}</StyledTableCell>
                        <StyledTableCell align="left" sx={{ width: 260 }}>{labelGrid.nome}</StyledTableCell>
                        <StyledTableCell align="left" sx={{ width: 170, whiteSpace: 'nowrap' }}>{labelGrid.cnpjCpf}</StyledTableCell>
                        <StyledTableCell align="right" sx={{ width: 120, whiteSpace: 'nowrap' }}>{labelGrid.total}</StyledTableCell>
                        <StyledTableCell align="center" sx={{ width: 130, whiteSpace: 'nowrap' }}>{labelGrid.lancamento}</StyledTableCell>
                        {!props.isHome && (
                            <StyledTableCell align="center" sx={{ width: 96 }}>{labelGrid.opcoes}</StyledTableCell>
                        )}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.length > 0 ? (
                        rows.map((row: any, index: number) => {
                            const status = statusPedidos?.find(
                                (item) => item.idStatusPedido === row.idStatusPedido
                            );
                            return (
                                <StyledTableRow key={index}>
                                    <StyledTableCell align="center">
                                        {/*<Tooltip
                      title={
                        status?.descricao
                          ? status.descricao.charAt(0).toUpperCase() + status.descricao.slice(1).toLowerCase()
                          : "Sem status"
                      }
                    >*/}
                                        <div
                                            style={{
                                                minWidth: 120,
                                                maxWidth: 120,
                                                padding: "4px",
                                                height: 16,
                                                borderRadius: "12px",
                                                backgroundColor: status
                                                    ? retornaOpcoesStatus(status.idStatusPedido)?.color
                                                    : "#FFFFFF",
                                                border: "1px solid #ddd",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                color: "white",
                                                fontSize: "0.775rem",
                                                fontWeight: 500,
                                                cursor: "default"
                                            }}
                                        >
                                            {status
                                                ? status.descricao.charAt(0).toUpperCase() + status.descricao.slice(1).toLowerCase()
                                                : "Sem status"}
                                        </div>
                                        {/*</Tooltip>*/}
                                    </StyledTableCell>

                                    {headers.map((key) => (
                                        <StyledTableCell
                                            key={`${index}-${key}`}
                                            align={
                                                key.toLowerCase() === 'total'
                                                    ? 'right'
                                                    : key.toLowerCase() === 'datalancamento' || key.toLowerCase() === 'nrodocumentopedido' || key.toLowerCase() === 'nropedido'
                                                        ? 'center'
                                                        : 'left'
                                            }
                                            sx={{
                                                fontSize: '12px',
                                                color: '#334155',
                                                padding: '5px 16px',
                                                borderBottom: '1px solid #E2E8F0',
                                                width: key.toLowerCase() === 'nome'
                                                    ? '50%'
                                                    : key.toLowerCase() === 'cnpjcpf'
                                                        ? '15%'
                                                        : key.toLowerCase() === 'nrodocumentopedido' || key.toLowerCase() === 'nropedido'
                                                            ? '5%'
                                                            : 'auto'
                                            }}
                                        >
                                            {row[key] !== undefined
                                                ? key.toLowerCase() === 'total'
                                                    ? formatNumbervalue(Number(row[key]), 2)
                                                    : key.toLowerCase() === 'cnpjcpf'
                                                        ? formatCnpjCpf(row[key])
                                                        : key.toLowerCase() === 'nome'
                                                            ? row.nome ?? 'Nome não informado'
                                                            : typeof row[key] === 'string' && row[key].includes('T')
                                                                ? formatarData(row[key])
                                                                : row[key]
                                                : '-'}
                                        </StyledTableCell>
                                    ))}
                                    {!props.isHome && (
                                        <TableCell align="center" sx={{ width: 96, padding: '2px 8px', borderBottom: '1px solid #E2E8F0' }}>
                                            {/*<Tooltip title={(retornaOpcoesStatus(row.idStatusPedido)?.editavel && row.agenteAtivo === "S") ? 'Editar' : 'Visualizar'}>
                        <IconButton
                          onClick={(retornaOpcoesStatus(row.idStatusPedido)?.editavel && row.agenteAtivo === "S")
                            ? () => props.handleEditarPedido(row)
                            : () => props.handleVisualizarPedido?.(row)
                          }
                          sx={{
                            backgroundColor: (retornaOpcoesStatus(row.idStatusPedido)?.editavel && row.agenteAtivo === "S") ? '#5693B9' : '#757575',
                            color: 'white',
                            padding: '4px',
                            '& .MuiSvgIcon-root': {
                              fontSize: '16px'
                            },
                            '&:hover': {
                              backgroundColor: (retornaOpcoesStatus(row.idStatusPedido)?.editavel && row.agenteAtivo === "S") ? '#4a7fa0' : '#757575'
                            }
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                      </Tooltip>*/}
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5, width: '100%' }}>
                                                <Tooltip title={'Editar'}>
                                                    <IconButton
                                                        size="small"
                                                        onClick={(retornaOpcoesStatus(row.idStatusPedido)?.editavel && row.agenteAtivo === "S")
                                                            ? () => props.handleEditarPedido(row)
                                                            : () => { }
                                                        }
                                                        sx={{
                                                            color: (retornaOpcoesStatus(row.idStatusPedido)?.editavel && row.agenteAtivo === "S") ? '#0965c1' : '#cbd5e1',
                                                            '&:hover': { color: '#1D4ED8', backgroundColor: 'rgba(37,99,235,0.08)' },
                                                            '&.Mui-disabled': { color: '#cbd5e1' },
                                                            '& .MuiSvgIcon-root': {
                                                                fontSize: '17px'
                                                            },
                                                        }}
                                                    >
                                                        <EditIcon sx={{ fontSize: '17px' }} />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title={'Visualizar'}>
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => props.handleVisualizarPedido?.(row)}
                                                        sx={{
                                                            color: '#0965c1',
                                                            '&:hover': { color: '#1D4ED8', backgroundColor: 'rgba(37,99,235,0.08)' },
                                                            '& .MuiSvgIcon-root': {
                                                                fontSize: '17px'
                                                            },
                                                        }}
                                                    >
                                                        <VisibilityIcon sx={{ fontSize: '17px' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </Box>

                                        </TableCell>
                                    )}
                                </StyledTableRow>
                            );
                        })
                    ) : (
                        <TableRow>
                            <TableCell colSpan={!props.isHome ? 8 : 7} align="center" sx={{ py: 6, borderBottom: 0 }}>
                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                                    <SearchOffIcon sx={{ fontSize: 36, color: '#94a3b8' }} />
                                    <Typography sx={{ fontSize: '14px', color: '#64748b', fontWeight: 500 }}>
                                        Nenhum pedido encontrado
                                    </Typography>
                                    <Typography sx={{ fontSize: '12px', color: '#94a3b8' }}>
                                        Tente ajustar os filtros de busca
                                    </Typography>
                                </Box>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
            {/* </ThemeProvider> */}
        </TableContainer>
    );
}

export default CustomOrderTableComponent;